<template>
	<v-container class="d-flex flex-column align-start" fluid pa-0 style="height: 100%;"
		:class="this.$store.entregaStore.state.selectedType === 2 || this.$store.entregaStore.state.selectedType === 3 ? 'scrollable-list-bak':''">
		<FullHeader />
		<EntregasContainer />
	</v-container>
</template>

<script>
import FullHeader from '../../Globals/Headers/FullHeader'
import EntregasContainer from './EntregasContainer'

export default {
	name: 'EntregaIndex',
	components: {FullHeader, EntregasContainer},
	data: () => ({
		loading: false
	}),
	mounted(){
	},
	methods: {
	}
};
</script>


<style>
	.scrollable-list{
		flex: 1 1 auto;
		height: 100%;
	}
	.scrollable-list #consultas-container{
		flex: 1 1 auto;
		height: 100%;
	}
</style>